<template>
    <div class="messageWrap">
        <!-- header -->
        <div class="header">
            <h3>您的店铺</h3>
            <div class="myShop">
                <div class="shopLeft">
                    <img :src="shop.main_img+'@!middle.jpg'" alt="">
                </div>
                <div class="shopCenter">
                    <h3>{{shop.districts}} | {{shop.shop_area}}</h3>
                    <p>{{shop.ctitle}}</p>
                    <ul>
                        <li v-for="(val,key,ind) in shop.autotag" :key="ind">
                            <span v-for="(item,ind) in val" :key="ind">{{item}}</span>
                        </li>
                    </ul>
                </div>
                <div class="shopRight">
                    <span>{{shop.money[0]}}</span>{{shop.money[1]}}
                </div>
            </div>
        </div>
        <!-- 查看店铺 -->
        <div class="lookShop">
            <div class="lsItem" v-for="(val,ind) in lookShop" :key="ind">
                <div class="lsItemLeft">
                    <div class="item_img">
                        <img :src="val.user.headimgurl" alt="">
                    </div>
                    <div class="item_content">
                        <h3><b>{{val.user.nickname}}</b>{{val.event}}</h3>
                        <p>{{val.user.mobile}}</p>
                    </div>
                </div>
                <div class="lsItemRight">
                    {{val.date}}
                </div>
            </div>
        </div>
        <!-- 登录后查看完整电话 -->
        <div class="lookPhone">
            <h2>登录后查看完整电话</h2>
            <div class="loginIpt">
                <input type="text" class="login_ipt" :v-model="form.ipt" :value="form.ipt"> 
            </div>
            <button class="login_btn" @click="loginLook">登录查看</button>
        </div>
        <!-- 找店人多 -->
        <div class="bottom">
            <div class="botton_item" v-for="(val,ind) in messageMeg" :key="ind">
                <img :class="[ind==0?'imgSpe':'']" :src="val.url" alt="">
                <h3>{{val.title}}</h3>
                <p>{{val.txt}}</p>
                <p>{{val.txt1}}</p>
            </div>
        </div>
        <Loading v-if="showTask"></Loading>
    </div>
</template>
<script>
import qs from 'qs';
import Loading from '@/components/Loading.vue'
export default {
    data(){
        return{
            lookShop:[],
            form:{
                ipt:''
            },
            messageMeg: [{
                url: require('../../../../public/images/zhuanti/message/message1.png'),
                title: '找店人多',
                txt: '每天超10000人找店',
                txt1: ''
            },{
                url: require('../../../../public/images/zhuanti/message/message2.png'),
                title: '全免费',
                txt: '不收取任何费用',
                txt1: '免费推广'
            },{
                url: require('../../../../public/images/zhuanti/message/message3.png'),
                title: '找店人多',
                txt: '平均28天转出',
                txt1: '最快5天'
            }],
            shop:{
                money:['','']
            },
            sms_code:'',
            showTask: true
        }
    },
    components:{
        Loading:Loading
    },
    created(){
        console.log(this.$route.query)
        if(JSON.stringify(this.$route.query) != '{}' && this.$route.query.sms_code != 'undefined' && this.$route.query.sms_code != undefined){
            this.sms_code = this.$route.query.sms_code
        }
        this.getData()
    },
    mounted(){
        
    },
    methods: {
        // 获取数据
        getData(){
            this.ajax.post('//api.lepu.cn/app/activity/sms-active',qs.stringify({sms_code:this.sms_code})).then(res=>{
                var res = res.data
                console.log(res)
                this.showTask = false
                if(res.data.code == 1){
                   this.lookShop = res.data.events
                   this.shop = res.data.shop
                   this.form.ipt = res.data.tel
                }else{
                    this.$toast({
                        message: res.note,
                        position: 'middle',
                        duration: 2000
                    })
                }
            })
        },
        // loginLook
        loginLook(){
            this.ajax.get('//api.lepu.cn/app/activity/sms-login').then(res=>{
                var res = res.data
                if(res.data.code == 1){
                    location.href = '//m.lepu.cn/'
                }else{
                    this.$toast({
                        message: res.note,
                        position: 'middle',
                        duration: 2000
                    })
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.messageWrap{
    width: 100%;
    height: 100%;
    padding-top: .1rem;
    box-sizing: border-box;
}

.header{
    width: 100%;
    padding: 0 .3rem .3rem;
    border-bottom: .06rem solid #f8f8f9;
    box-sizing: border-box;

    &>h3{
        width: 100%;
        height: .8rem;
        font-size: .28rem;
        line-height: .8rem;
    }

    .myShop{
        width: 100%;
        display: flex;

        .shopLeft{
            width: 25%;
            height: 1.4rem;
            flex-shrink: 0;

            &>img{
                width: 100%;
                height: 100%;
            }
        }

        .shopRight{
            width: 2rem;
            overflow: hidden;
            margin-top: .5rem;
            color: #e22222;
            white-space: nowrap;
            text-align: right;

            &>span{
                font-size: .36rem;
                font-weight: 900;
                padding-right: .01rem;
            }
        }

        .shopCenter{
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            margin-left: .1rem;

            &>h3{
                width: 100%;
                color: #333;
                width: 3.8rem;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                font-size: .26rem;
            }

            &>p{
                margin-top: .2rem;
                color: #777;
                width: 3.8rem;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }

            &>ul{
                width: 3.8rem;
                margin-top: .14rem;
                overflow-x: scroll;
                white-space: nowrap;
                
                li{
                    display: inline-block;
                    
                    span{
                        display: inline-block;
                        padding: .02rem .1rem;
                        background: #efefef;
                        box-sizing: border-box;
                        margin-right: .1rem;
                        font-size: .2rem;
                        color: #7c7c7c;
                    }
                }

            }
        }
    }
}

.lookShop{
    width: 100%;
    padding: .2rem .3rem;
    box-sizing: border-box;

    .lsItem{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: .2rem;

        .lsItemRight{
            margin-left: .2rem;
            color: #999;
        }

        .lsItemLeft{
            flex: 1;
            width: 100%;
            display: flex;
            align-items: center;
            
            .item_img{
                width: .84rem;
                height: .84rem;
                border-radius: 50%;
                overflow: hidden;
                margin-right: .2rem;

                img{
                    width: 100%;
                    height: 100%;
                }
            }

            .item_content{
                flex: 1;

                h3{
                    width: 100%;
                    height: .5rem;
                    font-size: .26rem;
                    color: #666;
                    line-height: .5rem;
                    width: 4.8rem;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    
                    b{
                        padding-right: .1rem;
                    }
                }

                p{
                    width: 100%;
                    color: #999;
                    font-size: .26rem;
                }
            }
        }
    }
}

.lookPhone{
    width: 100%;
    height: 2rem;
    padding: 0 .3rem;
    box-sizing: border-box;

    &>h2{
        width: 100%;
        height: .6rem;
        font-size: .28rem;
        line-height: .6rem;
    }

    .loginIpt{
        width: 100%;
        margin: .1rem 0;

        &>input{
            list-style: none;
            width: 100%;
            height: .6rem;
            line-height: .6rem;
            padding-left: .2rem;
            border: .01rem solid #ccc;
            border-radius: .1rem;
            box-sizing: border-box;
            color: #999;
            font-size: .26rem;
        }
    }

    &>button{
        width: 100%;
        height: .7rem;
        line-height: .7rem;
        text-align: center;
        color: #fff;
        font-size: .28rem;
        border:none;
        background: #dc2f34;
        border-radius: .1rem;
        margin-top: .2rem;
    }
}

.bottom{
    width: 100%;
    display: flex;
    margin-top: 1.2rem;

    .botton_item{
        width: 33.3%;
        text-align: center;

        img{
            width: .62rem;
            height: .62rem;
            border: 50%;
            overflow: hidden;
            margin-bottom: .3rem;
        }

        h3{
            font-size: .28rem;
            line-height: .44rem;
        }

        p{
            font-size: .22rem;
            color: #333;
            line-height: .44rem;
        }
    }
}

.imgSpe{
    width: .7rem!important;
    height: .58rem!important;
    margin-top: .04rem;
}
</style>